<template>
    <div class="layout align-center justify-center wrap container text-xs-center">

      <v-flex class="xs12 sm6 md2">
        <div>
          <v-card class="card card-pricing card-plain">
            <h6 class="card-category">{{$t('Free')}}</h6>
            <div class="card-body">
              <div class="card-icon icon-warning"> <v-icon style="font-size: 60px;">account_box</v-icon> </div>
              <h3 class="card-title">$0</h3>
              <ul><li>{{$t('PDF, 3D, JPEG')}}</li><li>{{$t('Public Blockchain')}}</li><li>&nbsp;</li></ul>
            </div>
            <div class="card-footer">
              <v-btn color="info">{{$t('Login')}}</v-btn>
            </div>
          </v-card>
        </div>
      </v-flex>

      <v-flex class="xs12 sm6 md2">
        <div>
          <v-card class="card card-pricing card-plain">
            <h6 class="card-category">{{$t('Professional')}}</h6>
            <div class="card-body">
              <div class="card-icon icon-warning"> <v-icon style="font-size: 60px;">supervisor_account</v-icon> </div>
              <h3 class="card-title">$99</h3>
              <ul><li>{{$t('Public Blockchain')}}</li><li>{{$t('300 sent documents')}}</li><li>{{$t('Unlimited documents')}}</li></ul>
            </div>
            <div class="card-footer">
              <v-btn color="info">{{$t('Buy')}}</v-btn>
            </div>
          </v-card>
        </div>
      </v-flex>

      <v-flex class="xs12 sm6 md2">
        <div>
          <v-card class="card card-pricing card-plain">
            <h6 class="card-category">{{$t('Enterprise')}}</h6>
            <div class="card-body">
              <div class="card-icon icon-warning"><v-icon style="font-size: 60px;">domain</v-icon></div>
              <h3 class="card-title">$ {{$t('Custom solution')}}</h3>
              <ul><li>{{$t('PDF, 3D, JPEG')}}</li><li>{{$t('Unlimited documents')}}</li><li>{{$t('Private Blockchain')}}</li></ul>
            </div>
            <div class="card-footer">
              <v-btn color="info">{{$t('Contact')}}</v-btn>
            </div>
          </v-card>
        </div>
      </v-flex>
    </div>
</template>

<script>
  import {  VIcon, VFlex, VCard, VBtn } from 'vuetify/lib';

  export default {
    name: 'Rates',
    components: {
      VIcon,
      VFlex,
      VCard,
      VBtn
    },
    data() {
      return {
        flipped: false,
      };
    }
  };
</script>

<style scoped>
  .flex{
    margin: 15px;
    padding: 8px;
  }
  .card-pricing ul {
    list-style: none;
    padding: 0;
    max-width: 240px;
    margin: 10px auto;
  }
  .card-pricing ul li {
    color: #888;
    text-align: center;
    padding: 12px 0;
    border-bottom: 1px solid hsla(0,0%,53.3%,.3);
  }
  .card-pricing ul {
    border-top: 1px solid hsla(0,0%,53.3%,.3);
  }
  .card-pricing .card-title {
    margin-top: 30px;
  }
  .card-title {
    margin-bottom: .75rem;
  }
  .circle {
    padding: 5px 20px;
    border-radius: 50%;
    font-size: 50px;
    color: #fff;
  }
  .free-account {
    background: #4DB3C7;
  }
  .professional-account {
    background: #6ACC56;
  }
  .enterprise-account {
    background: #E0196A;
  }
  .card-category, .category {
    text-transform: capitalize;
    font-weight: 400;
    color: #9a9a9a;
    font-size: .7142em;
  }
</style>
